import 'css-chunksrc/feature/provision/ProvisionPage.module.scss';export default {
  "content": "ProvisionPage_content",
  "content_header": "ProvisionPage_content_header",
  "content_main": "ProvisionPage_content_main",
  "content_footer": "ProvisionPage_content_footer"
};